import React from "react";
import { TESTIMONIALS } from "../../data";
import SectionHead from "./SectionHead";
import { Play } from "lucide-react";

const BASE = "https://customer-assets-lxgj4vgw.emergentagent.net/job_ticket-sales-flow/artifacts";

// Copertina SEMPRE prima (fissa).
const FIRST_REEL = {
  id: "non-so-vendere",
  label: "Ho capito ad oggi che non so vendere",
  cover: "/assets/fd94895460b6.webp",
  url: "https://www.instagram.com/7figuresalesrep/reel/DcaoVdQMz-4/",
};

// Le altre: ordine casuale, cambia una volta a settimana.
const OTHER_REELS = [
  { id: "obiezione", label: "questo mi fa un'obiezione", cover: "/assets/60629cb6cc91.webp", url: "https://www.instagram.com/7figuresalesrep/reel/DdJyn-UB_4T/" },
  { id: "figo", label: "Questo è figo, eh", cover: "/assets/65056bc46c8b.webp", url: "https://www.instagram.com/7figuresalesrep/reel/Dd_db5ozV01/" },
  { id: "diecimila", label: "€10.000 euro", cover: "/assets/da5caa6ad516.webp", url: "https://www.instagram.com/7figuresalesrep/reel/DcyHbMVt6cq/" },
  { id: "ventimila", label: "€20.000", cover: "/assets/d42e7fafc96e.webp", url: "https://www.instagram.com/7figuresalesrep/reel/Dcd-lKgMBeS/" },
  { id: "due-call", label: "Oi Claudio fatto due call", cover: "/assets/3cccbe8ff0e9.webp", url: "https://www.instagram.com/7figuresalesrep/reel/DejfBizM5QC/" },
  { id: "audio", label: "Metti questo fot**to audio", cover: "/assets/f213bcb46f9b.webp", url: "https://www.instagram.com/7figuresalesrep/reel/DeWjzu8MitR/" },
  { id: "voglia-vendere", label: "Mi è tornata la voglia di vendere", cover: "/assets/aede906eb350.webp", url: "https://www.instagram.com/7figuresalesrep/reel/Deg8-2JsurD/" },
];

// Numero della settimana corrente (ISO-ish): stabile entro la settimana, cambia ogni settimana.
function weekSeed() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 1);
  const week = Math.floor((now - start) / (7 * 24 * 60 * 60 * 1000));
  return now.getFullYear() * 100 + week;
}

// Shuffle deterministico (Fisher-Yates) con seed: stesso ordine per tutta la settimana.
function seededShuffle(arr, seed) {
  const a = [...arr];
  let s = seed % 233280;
  const rand = () => { s = (s * 9301 + 49297) % 233280; return s / 233280; };
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default function Testimonials() {
  const reels = [FIRST_REEL, ...seededShuffle(OTHER_REELS, weekSeed())];

  return (
    <section id="testimonianze" className="sec" style={{ background: "#00030F", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div className="mx-auto max-w-[1080px] px-4 lg:max-w-[1440px] lg:px-12">
        <SectionHead index={TESTIMONIALS.index} title={TESTIMONIALS.title} center />
        <p className="mt-4 mx-auto max-w-[60ch] text-center" style={{ fontSize: "1rem" }}>{TESTIMONIALS.intro}</p>

        <div className="mt-9 flex flex-wrap justify-center gap-4">
          {reels.map((r, i) => (
            <a
              key={r.id}
              href={r.url || undefined}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => { if (!r.url) e.preventDefault(); }}
              data-testid={`reel-card-${i}`}
              className="group relative block rounded-[16px] overflow-hidden w-[calc(50%-8px)] md:w-[calc(33.333%-11px)] lg:w-[calc(25%-12px)]"
              style={{ border: "1px solid var(--line)", background: "#05070F", aspectRatio: "9/16", cursor: r.url ? "pointer" : "default" }}
            >
              <img
                src={r.cover}
                alt={`Reel Instagram HighTicketSales — ${r.label}`}
                loading="lazy"
                className="w-full h-full object-cover transition duration-300 group-hover:scale-105"
                style={{ objectPosition: "center" }}
              />
              <div
                className="absolute inset-0 flex items-center justify-center"
                style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.12) 0%, rgba(0,0,0,0.28) 100%)", pointerEvents: "none" }}
              >
                <span
                  className="flex items-center justify-center rounded-full transition duration-300 group-hover:scale-110"
                  style={{ width: 50, height: 50, background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", border: "1px solid rgba(255,255,255,0.45)" }}
                >
                  <Play size={22} fill="#fff" className="text-white" style={{ marginLeft: 3 }} />
                </span>
              </div>
            </a>
          ))}
        </div>

        <p className="mt-8" style={{ fontSize: "0.92rem" }}>{TESTIMONIALS.disclaimer}</p>
      </div>
    </section>
  );
}
